import type { UndoOptions } from 'flow/editor/hooks/useWorkflowHistory/types';
import { createContext, useContext } from 'react';

export type WorkflowHistoryContextValue = {
  redo: () => void;
  undo: (opts?: UndoOptions) => void;
};

export const WorkflowHistoryContext = createContext<WorkflowHistoryContextValue | null>(null);

export function useWorkflowHistoryContext(): WorkflowHistoryContextValue {
  const context = useContext(WorkflowHistoryContext);

  if (!context) {
    throw new Error('useWorkflowHistoryContext must be used within WorkflowHistory');
  }

  return context;
}
